<template>
    <div class="test-list">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>用户分组任务</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="search" style="align-items: center;">
            <div>
                <el-button type="success" size="small" @click.native="dialogAddData = true">新增用户组任务</el-button>
            </div>
        </div>
        <div class="list" style="margin-top: 20px;">
            <el-table :data="groupTaskList" style="width: 100%" size="mini" stripe :row-class-name="tableRowClassName">
                <el-table-column prop="id" label="id"></el-table-column>
                <el-table-column prop="task_name" label="任务组名"></el-table-column>
                <el-table-column prop="month" label="月份"></el-table-column>
                <el-table-column prop="quarterly" label="季度"></el-table-column>
                <el-table-column prop="begin_time" label="开始时间"></el-table-column>
                <el-table-column prop="end_time" label="结束时间"></el-table-column>
                <el-table-column fixed="right" label="操作" width="280">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary"
                            @click="goToTaskData(scope.$index, scope.row)">跳转任务</el-button>
                        <el-button size="mini" type="success"
                            @click="putGroupTaskList(scope.$index, scope.row)">修改</el-button>
                        <el-button size="mini" type="danger"
                            @click="delGroupTaskList(scope.$index, scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="block">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages"
                :page-sizes="[10, 20, 30, 40]" :page-size="limit" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
        <el-dialog title="提示" :visible.sync="dialogDelete" width="30%" center>
            <div style="text-align: center;font-size: 25px;">是否删除这条数据</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogDelete = false">取 消</el-button>
                <el-button type="danger" @click="clickDelete">删 除</el-button>
            </span>
        </el-dialog>
        <!-- 添加 -->
        <el-dialog title="添加数据" :visible.sync="dialogAddData">
            <el-form :model="addData" :rules="rules" ref="addData">
                <el-form-item label="用户组任务名" :label-width="formLabelWidth" prop="task_name">
                    <el-input v-model="addData.task_name" autocomplete="off" placeholder="请输入用户组任务名"></el-input>
                </el-form-item>
                <el-form-item label="季度" :label-width="formLabelWidth">
                    <el-select v-model="addData.quarterly" placeholder="请选择季度" clearable>
                        <el-option v-for="item in quarterOptions" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="月份" :label-width="formLabelWidth">
                    <el-select v-model="addData.month" placeholder="请选择月份" clearable>
                        <el-option v-for="item in monthOptions" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="开始时间" :label-width="formLabelWidth">
                    <el-date-picker v-model="addData.begin_time" type="datetime" placeholder="请选择开始时间"
                        value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="结束时间" :label-width="formLabelWidth">
                    <el-date-picker v-model="addData.end_time" type="datetime" placeholder="请选择结束时间"
                        value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeDialogAdd">取 消</el-button>
                <el-button type="primary" @click="submitFormAdd">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 修改 -->
        <el-dialog title="修改用户组任务" :visible.sync="dialogEditData" width="50%">
            <el-form :model="editData" :rules="rules" ref="editData">
                <el-form-item label="用户组任务名" :label-width="formLabelWidth" prop="task_name">
                    <el-input v-model="editData.task_name" autocomplete="off" placeholder="请输入用户组任务名"></el-input>
                </el-form-item>
                <el-form-item label="季度" :label-width="formLabelWidth">
                    <el-select v-model="editData.quarterly" placeholder="请选择季度" clearable>
                        <el-option v-for="item in quarterOptions" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="月份" :label-width="formLabelWidth">
                    <el-select v-model="editData.month" placeholder="请选择月份" clearable>
                        <el-option v-for="item in monthOptions" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="开始时间" :label-width="formLabelWidth">
                    <el-date-picker v-model="editData.begin_time" type="datetime" placeholder="请选择开始时间"
                        value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                </el-form-item>
                <el-form-item label="结束时间" :label-width="formLabelWidth">
                    <el-date-picker v-model="editData.end_time" type="datetime" placeholder="请选择结束时间"
                        value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeDialogEdit">取消</el-button>
                <el-button type="primary" @click="submitFormEdit">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>


<script>
export default {
    data() {
        return {
            monthOptions: [
                { value: 1, label: '1月' },
                { value: 2, label: '2月' },
                { value: 3, label: '3月' },
                { value: 4, label: '4月' },
                { value: 5, label: '5月' },
                { value: 6, label: '6月' },
                { value: 7, label: '7月' },
                { value: 8, label: '8月' },
                { value: 9, label: '9月' },
                { value: 10, label: '10月' },
                { value: 11, label: '11月' },
                { value: 12, label: '12月' }
            ],
            quarterOptions: [
                { value: 1, label: '第一季度' },
                { value: 2, label: '第二季度' },
                { value: 3, label: '第三季度' },
                { value: 4, label: '第四季度' }
            ],
            formLabelWidth: '150px',
            pages: 1,
            limit: 10,
            groupTaskList: [],
            total: 0,
            group_id: '', // 分组id
            month: '', // 月
            quarterly: '', //季
            task_name: '',//用户任务组名
            dialogDelete: false, // 删除弹窗是否显示
            delData: {},
            findKey: '', // 查找的key
            dialogAddData: false, // 添加弹窗
            addData: {
                group_id: '',
                task_name: '',
                quarterly: '',
                month: '',
                begin_time: '',
                end_time: ''
            }, // 添加数据对象
            rules: {
                task_name: [
                    { required: true, message: '请输入用户组任务名', trigger: 'blur' }
                ]
            },
            dialogEditData: false, // 修改弹窗
            editData: {
                id: 0, // 任务ID（必填）
                group_id: '',
                task_name: '',
                quarterly: '',
                month: '',
                begin_time: '',
                end_time: ''
            },
        }
    },
    created() {
        this.getGroupTaskList()
    },
    methods: {
        getGroupTaskList() {
            let group_id = Number(this.$route.query.group_id)
            let params = {
                group_id: group_id
            };
            if (this.findKey) params.task_name = this.findKey;
            if (this.pages) params.pages = this.pages;
            if (this.limit) params.limit = this.limit;
            if (this.month) params.month = this.month;
            if (this.quarterly) params.quarterly = this.quarterly;
            let queryString = Object.entries(params)
                .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
                .join('&');

            this.$get(`/v1/admin/group-task?${queryString}`, {}).then((res) => {
                console.log(res)
                if (res.data.status != 'success') {
                    this.$msg(res.data.msg)
                } else {
                    let resultData = res.data
                    this.total = resultData.total
                    this.groupTaskList = resultData.data
                    console.log(resultData.data)
                }
            });
        },
        handleSizeChange(val) {
            console.log(val)
            this.limit = val;
            this.getGroupTaskList()
        },
        handleCurrentChange(val) {
            this.pages = val;
            this.getGroupTaskList()
        },
        tableRowClassName({ row, rowIndex }) {
            if (rowIndex % 2 === 1) {
                return '';
            } else {
                return 'success-row';
            }
        },
        // 删除用户组任务
        delGroupTaskList(index, row) {
            this.dialogDelete = true
            this.delData = row
        },
        clickDelete() {
            this.$delete(`/v1/admin/group-task?group_task_id=${this.delData.id}`, {}).then((res) => {
                if (res.data.status === 'success') {
                    this.$message.success('删除成功')
                    this.getGroupTaskList()
                    this.dialogDelete = false
                } else {
                    this.$msg(res.data.msg)
                }
            });
        },
        // 添加相关
        submitFormAdd() {
            this.$refs.addData.validate((valid) => {
                if (valid) {
                    // 开始时间和结束时间校验（可选）
                    if (this.addData.begin_time && this.addData.end_time &&
                        new Date(this.addData.begin_time) >= new Date(this.addData.end_time)) {
                        this.$message.error('开始时间必须早于结束时间');
                        return;
                    }
                    this.addData.group_id = Number(this.$route.query.group_id);
                    this.addTaskList(this.addData);
                }
            });
        },
        addTaskList(info) {
            let apiData = {
                group_id: info.group_id,
                task_name: info.task_name
            };

            if (info.quarterly) apiData.quarterly = info.quarterly;
            if (info.month) apiData.month = info.month;
            if (info.begin_time) apiData.begin_time = info.begin_time;
            if (info.end_time) apiData.end_time = info.end_time;
            console.log(apiData, 'apiData')
            this.$post(`/v1/admin/group-task`, apiData).then((res) => {
                console.log(res, 'resres')
                if (res.data.status === 'success') {
                    this.$message.success(res.data.msg)
                    this.getGroupTaskList()
                    this.closeDialogAdd()
                } else {
                    this.$msg(res.data.msg)
                }
            });
        },
        // 重置表单优化
        closeDialogAdd() {
            this.dialogAddData = false;
            this.$refs.addData.resetFields();
            let newArrddData = {
                group_id: '',
                task_name: '',
                quarterly: '',
                month: '',
                begin_time: '',
                end_time: ''
            }
            this.addData = newArrddData
        },
        // 修改相关
        putGroupTaskList(index, row) {
            const handleEmptyValue = (value) => {
                return value === 0 || value === null ? '' : value;
            };
            this.editData = {
                ...row,
                group_id: Number(this.$route.query.group_id),
                quarterly: handleEmptyValue(row.quarterly), // 处理季度
                month: handleEmptyValue(row.month), // 处理月份
                begin_time: row.begin_time || '',
                end_time: row.end_time || ''
            };
            this.dialogEditData = true;
        },
        submitFormEdit() {
            this.$refs.editData.validate((valid) => {
                if (valid) {
                    const apiData = {
                        group_task_id: this.editData.id,
                        group_id: this.editData.group_id,
                        task_name: this.editData.task_name
                    };
                    if (this.editData.quarterly !== '') apiData.quarterly = this.editData.quarterly;
                    if (this.editData.month !== '') apiData.month = this.editData.month;
                    if (this.editData.begin_time !== '') apiData.begin_time = this.editData.begin_time;
                    if (this.editData.end_time !== '') apiData.end_time = this.editData.end_time;

                    this.$put(`/v1/admin/group-task`, apiData).then((res) => {
                        console.log(res, 'resres')
                        if (res.data.status === 'success') {
                            this.$message.success(res.data.msg)
                            this.getGroupTaskList()
                            this.closeDialogEdit()
                        } else {
                            this.$msg(res.data.msg)
                        }
                    });
                }
            });
        },
        closeDialogEdit() {
            this.dialogEditData = false;
            this.$refs.editData.resetFields();
            this.editData = {
                id: 0,
                group_id: '',
                task_name: '',
                quarterly: '',
                month: '',
                begin_time: '',
                end_time: ''
            };
        },
        goToTaskData(index, row) {
            console.log(index, row, '----------')
            this.$router.push({
                path: '/taskData',
                query: {
                    taskName: row.task_name,
                    id: row.id,
                }
            });
        }
    }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.flex_box{
    margin: 12px;
    text-align right
}

.flex_box div {
    margin 10px
}

.right_box div {
    margin 10px
}
.right_box{
    color: red;
}

.dialog_style{
    display flex
    align-items center
    justify-content center
    font-size 19px
    color #000
}

   .el-select .el-input {
      width: 200px;
    }
  .test-list
      .el-table .warning-row {
        background: oldlace;
      }
  
      .el-table .success-row {
        background: #f0f9eb;
      }
  
      .search
        margin 20px 0
        display flex
        justify-content flex-start
        input
          width 220px
          margin-right 20px
        .add
          padding-left 100px
  
      .list
        min-height 550px
        border 1px solid #EBEEF5
        .edit_icon
          width 20px
          height 20px
          margin-left 16px
          border 1px solid  #ccc
          border-radius 4px
  
  </style>
<style scoped>
.custom-content {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    max-height: 100px;
    line-height: normal;
}
</style>


// WEBPACK FOOTER //
// src/pages/user_grouping/group-tasks.vue